import type { OsasTreatmentData } from '@common/validation/customControls/osas/osasTreatmentChoice/types';
import type { ValidationErrors } from '@frontend/utils/validation';
import { BooleanRadioGroupFormGroup, SelectWithUnitsFormGroup } from '../../../../processActivityFormGroupFields';
import { weeksOptions } from '../weeksOptions';
import { TreatmentTextInput } from './TreatmentTextInput';

type LifestyleFormGroupProps = {
    data: OsasTreatmentData;
    errors: ValidationErrors;
    onChange: (data: Partial<OsasTreatmentData>, validateKeys?: string | string[] | undefined) => void;
};
export function LifestyleFormGroup(props: Readonly<LifestyleFormGroupProps>) {
    const { data, errors, onChange } = props;

    return (
        <>
            <TreatmentTextInput
                data={data}
                errors={errors}
                onChange={onChange}
                treatmentName={'lifestyle'}
            />

            {!(data.treatment.CPAP || data.treatment.MRA || data.treatment.SPT || data.treatment.refer) && (
                <>
                    <BooleanRadioGroupFormGroup
                        fieldKey="shouldHaveFollowingExamination"
                        isRequired={true}
                        label="Vervolg slaaponderzoek"
                        onChange={async (value) => {
                            onChange(
                                {
                                    shouldHaveFollowUpConsult: null,
                                    shouldHaveFollowingExamination: value,
                                    taskFollowingExaminationOrConsultWeeks: value ? 16 : null,
                                },
                                ['shouldHaveFollowingExamination', 'taskFollowingExaminationOrConsultWeeks']
                            );
                        }}
                        type="radio"
                        value={data.shouldHaveFollowingExamination}
                    />

                    {data.shouldHaveFollowingExamination === false && (
                        <BooleanRadioGroupFormGroup
                            fieldKey="shouldHaveFollowUpConsult"
                            isRequired={true}
                            label="Vervolgconsult"
                            onChange={async (value) => {
                                onChange(
                                    {
                                        shouldHaveFollowUpConsult: value,
                                        taskFollowingExaminationOrConsultWeeks: value ? 16 : null,
                                    },
                                    ['shouldHaveFollowUpConsult', 'taskFollowingExaminationOrConsultWeeks']
                                );
                            }}
                            type="radio"
                            value={data.shouldHaveFollowUpConsult}
                        />
                    )}

                    {(data.shouldHaveFollowingExamination || data.shouldHaveFollowUpConsult) && (
                        <SelectWithUnitsFormGroup
                            fieldKey=""
                            isClearable={false}
                            label={data.shouldHaveFollowingExamination ? 'Vervolgonderzoek na' : 'Vervolgconsult na'}
                            onChange={async (value) => {
                                onChange(
                                    { taskFollowingExaminationOrConsultWeeks: parseInt(value ?? '') ?? null },
                                    'taskFollowingExaminationOrConsultWeeks'
                                );
                            }}
                            options={weeksOptions}
                            units="weken"
                            value={data.taskFollowingExaminationOrConsultWeeks?.toString()}
                        />
                    )}
                </>
            )}
        </>
    );
}
